import React, { useState } from 'react';
import { Modal, Button, Input, message } from 'antd';
import { useSendTermsAndConditions, useAcceptTermsAndConditions } from "@/hooks/admin/profile";

interface TermsAndConditionsModalProps {
    visible: boolean;
    onClose: () => void;
}

export const TermsAndConditionsModal: React.FC<TermsAndConditionsModalProps> = ({
                                                                                    visible,
                                                                                    onClose
                                                                                }) => {
    const [otp, setOtp] = useState('');
    const { mutate: sendTerms, isPending: isSending } = useSendTermsAndConditions();
    const { mutate: acceptTerms, isPending: isAccepting } = useAcceptTermsAndConditions();

    const handleSendTerms = () => {
        sendTerms();
        message.success('Terms and conditions sent. Please check your phone or email for the OTP.');
    };

    const handleAcceptTerms = () => {
        acceptTerms({ otp });
        message.success('Terms and conditions accepted successfully.');
        onClose();
    };

    return (
        <Modal
            title="Accept Terms and Conditions"
            open={visible}
            onCancel={onClose}
            footer={[
                <Button key="send" onClick={handleSendTerms} loading={isSending}>
                    Send Terms and Conditions
                </Button>,
                <Button key="accept" type="primary" onClick={handleAcceptTerms} loading={isAccepting}>
                    Accept Terms
                </Button>
            ]}
        >
            <p>Please click the button below to receive the terms and conditions via SMS or email.</p>
            <p>Once you've reviewed the terms, enter the OTP you received and click 'Accept Terms'.</p>
            <Input
                placeholder="Enter OTP"
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                style={{ marginTop: 16 }}
            />
        </Modal>
    );
};